(() => {
  const installation = Symbol.for('kretogum.purchaseOptions.v003');
  if (document[installation]) {
    document[installation].init(document);
    return;
  }

  const selector = '[data-kreto-purchase]';
  const controllers = new Map();

  class PurchaseOptions {
    constructor(root) {
      this.root = root;
      this.sectionId = root.closest('product-info')?.dataset.section;
      this.onChange = () => this.update();
      root.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.variantChanged(event));
      }
      this.update();
    }

    update() {
      const radios = [...this.root.querySelectorAll('input[type="radio"]')];
      let selected = radios.find((radio) => radio.checked && !radio.disabled);
      if (!selected) {
        selected = radios.find((radio) => !radio.disabled);
        if (selected) selected.checked = true;
      }
      const plan = this.root.querySelector('[data-kreto-plan-select]');
      const input = this.root.querySelector('[data-kreto-selling-plan]');
      const frequency = this.root.querySelector('.kreto-purchase__frequency');
      const subscribed = selected?.value === 'subscribe' && Boolean(plan?.selectedOptions.length);
      if (input) {
        input.disabled = !subscribed;
        input.value = subscribed ? plan.value : '';
      }
      if (frequency) frequency.hidden = !subscribed;
      if (plan) plan.disabled = !subscribed;
      const price = plan?.selectedOptions[0]?.dataset.price;
      const priceNode = this.root.querySelector('[data-kreto-subscription-price]');
      if (price !== undefined && priceNode) priceNode.textContent = price;
    }

    variantChanged({ data } = {}) {
      if (!data || !this.sectionId || String(data.sectionId) !== String(this.sectionId)) return;
      if (!this.root.isConnected) {
        this.destroy();
        controllers.delete(this.root);
        return;
      }
      const candidates = [...(data.html?.querySelectorAll(selector) || [])];
      const source = candidates.find((root) => root.closest('product-info')?.dataset.section === this.sectionId)
        || (candidates.length === 1 ? candidates[0] : null);
      if (!source) return;
      const mode = this.root.querySelector('input[type="radio"]:checked')?.value;
      const planId = this.root.querySelector('[data-kreto-plan-select]')?.value;
      const focused = this.root.contains(document.activeElement) ? document.activeElement : null;
      const focusedMode = focused?.matches('input[type="radio"]') ? focused.value : null;
      const focusedPlan = focused?.matches('[data-kreto-plan-select]');

      this.root.replaceChildren(...[...source.childNodes].map((node) => node.cloneNode(true)));
      const radios = [...this.root.querySelectorAll('input[type="radio"]')];
      const retainedMode = radios.find((radio) => radio.value === mode && !radio.disabled);
      if (retainedMode) radios.forEach((radio) => { radio.checked = radio === retainedMode; });
      const plan = this.root.querySelector('[data-kreto-plan-select]');
      if (plan && [...plan.options].some((option) => option.value === planId && !option.disabled)) {
        plan.value = planId;
      }
      this.update();
      const focusTarget = focusedPlan && plan && !plan.disabled ? plan
        : radios.find((radio) => radio.value === focusedMode && !radio.disabled);
      focusTarget?.focus({ preventScroll: true });
    }

    destroy() {
      this.root.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
      this.unsubscribe = null;
    }
  }

  const init = (scope = document) => {
    for (const [root, controller] of controllers) {
      if (!root.isConnected) {
        controller.destroy();
        controllers.delete(root);
      }
    }
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    roots.forEach((root) => {
      if (!controllers.has(root)) controllers.set(root, new PurchaseOptions(root));
    });
  };
  document[installation] = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, controller] of controllers) {
      if (event.target === root || event.target.contains(root)) {
        controller.destroy();
        controllers.delete(root);
      }
    }
  });
})();
